import { Base } from './base.model';
import { EnrollmentGroup } from './enrollment-group.model';
import { SiteStatus } from './site-status';

import { Type } from '../decorators/type.decorator';

export class SiteBase extends Base {
  public acceptedCustomTerms: boolean;
  public applicantId: number;
  public activationDate: Date;
  public allowedClearing: number;
  public annualPayment: number;
  public approvedDate: Date;
  public area: number;
  public assignedAdminId?: number;
  public canceledById: number;
  public canceledDate: Date;
  public calculatedBuffer: number;
  @Type(EnrollmentGroup) public enrollmentGroup: EnrollmentGroup;
  public enrollmentGroupId: number;
  public contractEnvelopeId: string;
  public createDate: Date;
  public createdAt?: string;
  public currentStep?: string;
  public eDocFulfilled: boolean;
  public enrollmentGroupBuffer: number;
  public forestryFirm: string;
  public hasRestrictions: boolean;
  public hasSmallClearing: boolean;
  public identifier: string;
  public initialAdjustment: number;
  public initialLat: number;
  public initialLng: number;
  public lastRegionUpdate: Date;
  public mortgageInformation: string;
  public maxAnnualPayment: number;
  public name: string;
  public namesOnDeed: string;
  public netErt: number;
  public financialNetErt: number;
  public grossErt: number;
  public needsReview: boolean;
  public otherPrograms: string;
  public originalSubmittedDate: Date;
  public parcelOverlaps: boolean;
  public parcelMetadata: any;
  public potentialArea: number;
  public simulatedFinancials: any;
  public financials: any;
  public siteOverlaps: number[];
  public standOverage: number;
  public timeInStatus: number;
  public timeInCategory: number;
  public status: string;
  @Type(SiteStatus) public siteStatus: SiteStatus;
  public submittedDate: Date;
  public updatedAt: Date;
  public valuation: string;
  public valuationCheck: number;
  public yieldCurveVersion: number;
}
